export default __webpack_public_path__ + "610e08e34a9296b4f9e91cb044463474.png";